import ActionTypes from '../constants/action-types';
import store from '../../redux/reducers/reducer';
import { captureException } from '@sentry/react';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancel;

export const setStash = payload => {
    return {
        type: ActionTypes.SET_STASH,
        payload
    };
};

export const getStash = (args) => async (dispatch) => {
    const state = store.getState().stash;
    const message = store.getState().message;
    const reset = args.reset ?? false;
    const needsInformation = args.needs_information ?? false;

    if (state.busy || (!reset && !state.hasMore)) {
        return;
    }

    dispatch({
        type: ActionTypes.SET_STASH_BUSY,
        payload: true
    });

    let payload = {
        'msg-stats'    : true,
        'all_media'    : 'yes',
        'filter_type'  : state.filterType,
        'sort'         : state.sort,
        'to_date'      : state.filterType === 'custom' ? state.filterToDate.format('YYYY-MM-DD') : '',
        'stash_filter' : state.filter
    };

    if (args && args.page == 1) {
        dispatch({
            type: ActionTypes.SET_STASH_CURRENT_PAGE,
            payload: 1
        });
    }

    await axios.get(`/api/medias`, {
        params: {
            ...payload,
            ...args
        },
        cancelToken: new CancelToken((c) => {
            cancel = c;
        }),
    })
        .then(response => {
            dispatch({
                type: ActionTypes.SET_STASH_BUSY,
                payload: false
            });

            if (needsInformation && !message.broadcastModal) {
                // get media ids only
                const mediaIds = response.data.data.map(media => media.media_id);

                dispatch({
                    type: ActionTypes.SET_STASH_GET_INFORMATION,
                    payload: mediaIds
                });
            }

            if (reset) {
                dispatch({
                    type: ActionTypes.SET_STASH_HASMORE,
                    payload: true
                });
            }

            let tmp = [...state.medias];
            const mediaIds = new Set(tmp.map(media => media.media_id));
            tmp = [...tmp, ...response.data.data.filter(d => !mediaIds.has(d.media_id))];

            dispatch({
                type: ActionTypes.SET_STASH_MEDIAS,
                payload: tmp
            });

            // if (state.medias.length === 0 || reset) {
            //     dispatch({
            //         type: ActionTypes.SET_STASH_MEDIAS,
            //         payload: response.data.data
            //     });

            //     dispatch({
            //         type: ActionTypes.SET_STASH_HASMORE,
            //         payload: true
            //     });

            // } else {
            //     let tmp = [...state.medias];
            //     const mediaIds = new Set(tmp.map(media => media.media_id));
            //     tmp = [...tmp, ...response.data.data.filter(d => !mediaIds.has(d.media_id))];

            //     dispatch({
            //         type: ActionTypes.SET_STASH_MEDIAS,
            //         payload: tmp
            //     });
            // }

            if (response.data.data.length < args.per_page) {
                dispatch({
                    type: ActionTypes.SET_STASH_HASMORE,
                    payload: false
                });
            }

        }).catch(error => {
            console.log({ error });
            dispatch({
                type: ActionTypes.SET_STASH_BUSY,
                payload: false
            });
        });
};

export const callCancel = () => (dispatch) => {
    if (cancel !== undefined) {
        cancel();
    }

    return;
};

export const getMediasSent = (params) => async (dispatch) => {
    const messengerStash = store.getState().message;
    const state = store.getState().stash;

    if (state.stashSidebar) {
        return '';
    }

    const formData = new FormData();

    if (!(messengerStash.broadcastModal || state.stashSidebar)) {
        formData.append('other_user', localStorage.getItem('other_user'));
    }

    formData.append('sidebar', messengerStash.broadcastModal || state.stashSidebar);

    await axios({
        method: 'post',
        url: '/api/getMediaSent',
        data: formData,
    })
        .then((data) => {
            dispatch({
                type: ActionTypes.SET_STASH_MEDIA_SENT,
                payload: data.data.media_sent
            });

            dispatch({
                type: ActionTypes.SET_STASH_MEDIA_SOLD,
                payload: data.data.sold
            });
        })
        .catch((error) => {
            console.error({ error });
        });
};

export const setStashHasMore = (payload) => {
    return {
        type: ActionTypes.SET_STASH_HASMORE,
        payload
    };
};

export const setStashBusy = (payload) => {
    return {
        type: ActionTypes.SET_STASH_BUSY,
        payload
    };
};

export const setStashFilter = (payload) => {
    return {
        type: ActionTypes.SET_STASH_FILTER,
        payload
    };
};

export const setStashAlbums = (payload) => {
    return {
        type: ActionTypes.SET_STASH_ALBUMS,
        payload
    };
};

export const setStashTabSelected = (payload) => {
    return {
        type: ActionTypes.SET_STASH_TAB_SELECTED,
        payload
    };
};

export const setAlbumAction = (payload) => {
    return {
        type: ActionTypes.SET_ALBUM_ACTION,
        payload
    };
};

export function setActiveAlbum(payload) {
    return {
        type: ActionTypes.SET_ACTIVE_ALBUM,
        payload,
    };
}

export const handleAlbumAction = (action) => {

    if (action === 'new_album') {
        const payload = {
            showAlbumModal: true
        };

        const stash = getStash();

        return setStash({
            ...stash,
            ...payload
        });
    }

    return setAlbumAction(action);
};

export function setShowAlbumModal(payload) {
    return {
        type: ActionTypes.SET_NEW_ALBUM_FORM,
        payload,
    };
}

export function setStashMedias(payload) {
    return {
        type: ActionTypes.SET_STASH_MEDIAS,
        payload
    };
}

export const getAlbums = (args) => async (dispatch, getState) => {
    const state = store.getState().stash;
    dispatch({
        type: ActionTypes.SET_STASH_BUSY,
        payload: true
    });

    await axios.get('/api/albums')
        .then((response) => {
            dispatch({
                type: ActionTypes.SET_STASH_ALBUMS,
                payload: response.data
            });

            dispatch({
                type: ActionTypes.SET_STASH_BUSY,
                payload: false
            });
            if (state.activeAlbum && Object.keys(state.activeAlbum).length > 0) {
                const index = response.data.findIndex(a => a.id == state.activeAlbum.id);

                if (index >= 0) {
                    dispatch({
                        type: ActionTypes.SET_STASH_ALBUM_MEDIAS,
                        payload: response.data[index].medias
                    });
                }
            }

        })
        .catch((error) => {
            captureException(error);
        });
};

export function setStashSelectedR(payload) {
    return {
        type: ActionTypes.SET_STASH_SELECTED,
        payload
    };
}
export function setStashShow(payload) {
    return {
        type: ActionTypes.SET_STASH_SHOW,
        payload
    };
}

export function setStashSidebar(payload) {
    return {
        type: ActionTypes.SET_STASH_SIDEBAR,
        payload,
    };
}

export function setStashToGetInfo(payload) {
    return {
        type: ActionTypes.SET_STASH_TO_GET_INFO,
        payload,
    };
}


export function setAddMediaToAlbum(payload) {
    return {
        type: ActionTypes.SET_ADD_MEDIA_TO_ALBUM,
        payload,
    };
}

export function setStashAlbumMedias(payload) {
    return {
        type: ActionTypes.SET_STASH_ALBUM_MEDIAS,
        payload,
    };
}

export function setStashActiveAlbum(payload) {
    return {
        type: ActionTypes.SET_STASH_ACTIVE_ALBUM,
        payload,
    };
}

export function setOrderModal(payload) {
    return {
        type: ActionTypes.SET_ORDER_MODAL,
        payload,
    };
}

export function setStashAlbumGetInfo(payload) {
    return {
        type: ActionTypes.SET_STASH_ALBUM_GET_INFORMATION,
        payload
    };
}

export function setStashActiveAlbumMedias(payload) {
    return {
        type: ActionTypes.SET_STASH_ACTIVE_ALBUM_MEDIAS,
        payload
    };
}

export function setMediaSent(payload) {
    return {
        type: ActionTypes.SET_STASH_MEDIA_SENT,
        payload
    };
}

export function setMediaSold(payload) {
    return {
        type: ActionTypes.SET_STASH_MEDIA_SOLD,
        payload
    };
}

export const getSoldPostMedias = (params) => async (dispatch) => {
    const messengerStash = store.getState().message;
    const state = store.getState().stash;

    if (state.stashSidebar) {
        return '';
    }

    await axios.get('/api/posts/sent', {
        params: {
            other_user: localStorage.getItem('other_user'),
            sidebar: messengerStash.broadcastModal || state.stashSidebar
        }
    })
        .then((data) => {
            return {
                type: ActionTypes.SET_SOLD_POST_MEDIAS,
                payload: data.data
            };
        })
        .catch((error) => {
            console.error({ error });
        });
};

export function setTempSelected(payload) {
    return {
        type: ActionTypes.SET_TEMP_STASH_SELECTED,
        payload
    };
}

export const prependMediaToMedias = (payload) => {
    return {
        type: ActionTypes.PREPEND_MEDIA_TO_MEDIAS,
        payload
    };
};

export const resetStashMedias = (payload) => {
    return {
        type: ActionTypes.RESET_STASH_MEDIAS,
        payload
    };
};

export const setStashAlbumListScrollPosition = (payload) => {
    return {
        type: ActionTypes.SET_STASH_ALBUM_LIST_SCROLL_POSITION,
        payload
    };
};

export const setStashReset = (payload) => {
    return {
        type: ActionTypes.SET_STASH_RESET,
        payload
    };
};

export const setStashType = (payload) => {
    return {
        type: ActionTypes.SET_STASH_TYPE,
        payload
    };
}

export const setStashSort = (payload) => {
    return {
        type: ActionTypes.SET_STASH_SORT,
        payload
    };
}

export const setFilterToDate = (payload) => {
    return {
        type: ActionTypes.SET_STASH_FILTER_TO_DATE,
        payload
    };
}

export const setStashCurrentPage = (payload) => {
    return {
        type: ActionTypes.SET_STASH_CURRENT_PAGE,
        payload
    };
}
